import { IGetDataAuditoriaDropDownUseCase } from "../../../presentation/useCases/read/get_data_auditoria_drop_down_use_case";
import { DataAuditoriaDropDown } from "../../models/data_auditoria_dropdown";
import { ICommonsRepository } from "../../repositories/commons_repository";

//GetDataAuditoriaDropDownUseCase

export class GetDataAuditoriaDropDownUseCase implements IGetDataAuditoriaDropDownUseCase {
  constructor(private readonly repository: ICommonsRepository) { }

  async getDataAuditoriaDropDown(): Promise<DataAuditoriaDropDown[]> {
    return await this.repository.getDataAuditoriaDropDown();
  }
}
